import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { PHBHPFeaturePackageElearningService } from "../ph-bhp-feature-package-elearning.service";
import { SopDetail } from '../Models';
import { PHBHPStartpuzzleComponent } from "../ph-bhp-startpuzzle/ph-bhp-startpuzzle.component";
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { TranslateService } from '@ngx-translate/core';
import { TranslationKeys } from 'ph-bhp-localization'
@Component({
  selector: 'lib-ph-bhp-managepuzzles',
  templateUrl: './ph-bhp-managepuzzles.component.html',
  styleUrls: ['./ph-bhp-managepuzzles.component.css']
})
export class PHBHPManagepuzzlesComponent implements OnInit {

  @Output() childData = new EventEmitter();
  @Input() userData: any;
  @Input() sopId: number;
  @Input() isDesktop = true;
  modalRef: BsModalRef;
  userFlag = true;
  sopDatails: Array<SopDetail> = [];
  allSopDatails: Array<SopDetail> = [];
  draftSopDatails: Array<SopDetail> = [];
  publishedSopDatails: Array<SopDetail> = [];
  translationKeys: typeof TranslationKeys = TranslationKeys;

  constructor(public layoutService: PHBHPLayoutPackageService, private service: PHBHPFeaturePackageElearningService, private modalService: BsModalService, private translate: TranslateService) { }

  ngOnInit() {
  }

  ngOnChanges() {
    this.layoutService.showLoader = true;

    if (this.userData && this.userFlag) {
      this.userFlag = false;
      this.service.getPuzzlesbyActiveInstitution(this.userData.userId, this.layoutService.institutionID).subscribe((res: Array<SopDetail>) => {
        this.layoutService.showLoader = false;
        this.sopDatails = res;
        this.allSopDatails = this.sopDatails;
        //this.draftSopDatails = this.sopDatails.filter((res) => res.draftStepsJson != '')
        //this.publishedSopDatails = this.sopDatails.filter((res) => res.draftStepsJson == '')
      });

      /*this.service.getSOPDetails(this.userData.userId).subscribe((res: Array<SopDetail>) => {
        this.layoutService.showLoader = false;
        this.sopDatails = res;
        this.allSopDatails = this.sopDatails;
        //this.draftSopDatails = this.sopDatails.filter((res) => res.draftStepsJson != '')
        //this.publishedSopDatails = this.sopDatails.filter((res) => res.draftStepsJson == '')
      });*/
    }
  }

  openSOP(sopId) {
    var initialState = {
      isDesktop: this.isDesktop,
      sopId: sopId,
      userData: this.userData
    };
    if (this.isDesktop) {
    this.modalRef = this.modalService.show(PHBHPStartpuzzleComponent, { initialState, class: 'modal-full w-full' });
      this.modalRef.content.action.subscribe((value) => {
        switch (value.key) {
          case 'backToElearning':
            this.modalRef.hide()
            // this.selectIndex = null;
            // this.activeClass = {};
            // this.service.isCollapsed = !this.service.isCollapsed;
            // this.modalRef = this.modalService.show(this.template,
            //   Object.assign({}, { class: 'w-420' }));
            break;
        }
      });
    } else {
      this.childData.emit({ key: 'startPuzzle', data: initialState });
    }

  }

  emitData(key: any, value: any = null) {
    this.childData.emit({ key: key, val: value });
  }
}
